/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseOfString } from '../../models/api-response-of-string';
import { Note } from '../../models/note';

export interface NotesTemplateCreatePdf$Params {
  patientId: string | null;
      body: Note
}

export function notesTemplateCreatePdf(http: HttpClient, rootUrl: string, params: NotesTemplateCreatePdf$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseOfString>> {
  const rb = new RequestBuilder(rootUrl, notesTemplateCreatePdf.PATH, 'post');
  if (params) {
    rb.path('patientId', params.patientId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseOfString>;
    })
  );
}

notesTemplateCreatePdf.PATH = '/patient{patientId}/notes/CreatePdf';
